import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";

const SearchResults = ({ loading, results, searchQuery }) => {
  console.log(results, "resultsresults");
  // Function to highlight search query in results
  const highlightText = (text, query) => {
    const parts = text.split(new RegExp(`(${query})`, "gi"));
    return (
      <span>
        {parts.map((part, i) =>
          part.toLowerCase() === query.toLowerCase() ? (
            <strong key={i} style={{ backgroundColor: "yellow" }}>
              {part}
            </strong>
          ) : (
            part
          ),
        )}
      </span>
    );
  };

  return results.map((row) => (
    <Box component="li" key={row.id}>
      <Box>
        <Typography variant="body1">
          {highlightText(row.first_name + " " + row.last_name, searchQuery)}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {highlightText(row.email_id, searchQuery)}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {highlightText(row.mobile_no, searchQuery)}
        </Typography>
      </Box>
    </Box>
  ));
};

export default SearchResults;
